import React from "react";
import { FaGoogle } from "react-icons/fa";
import "./GoogleReviewCard.scss";   

const GoogleReviewCard = ({ name, review }) => {
    return (
        <div className="google-review-card">
            <h3 className="grc-name">{name}</h3>

            <div className="grc-stars" role="img" aria-label="5 out of 5 stars">
                {[...Array(5)].map((_, i) => (
                    <span key={i} aria-hidden="true">★</span>
                ))}
            </div>

            <p className="grc-text">“{review}”</p>

            <FaGoogle className="grc-icon" role="img" aria-label="Google review" />
        </div>
    );
};

export default GoogleReviewCard;
